<template>
  <div class="formBox">
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-text-field v-model="bookForm.gsjg"  :rules="organizationRules" label="单位名称" required dark></v-text-field>

            <v-text-field v-model="bookForm.lxrxm" :rules="nameRules" label="联系人姓名" required dark></v-text-field>

            <v-text-field v-model="bookForm.lxyx" :rules="emailRules" label="邮箱" required dark></v-text-field>

            <v-text-field v-model="bookForm.lxdh"  label="手机号码" :rules="telRules" required dark></v-text-field>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
    <v-btn outlined color="white" class="btn-dark"  @click='submit' :disabled="!valid">预约参观</v-btn>
     <v-dialog
      v-model="dialog"
      width="500"
    >
      <v-card>
        <v-toolbar
          color="primary"
          dark
        >提示</v-toolbar>
        <v-card-text>
          <div class="body_text pa-12" v-text='dialog_tip'></div>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
            text
            @click="dialog= false"
          >关闭</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'booking',

  props: {

  },

  data: () => ({
    // 表单验证
    valid: false,
    dialog: false,
    dialog_tip: '',
    nameRules: [
      v => !!v || '请输入联系人姓名'
    ],
    emailRules: [
      v => !!v || '请输入邮箱',
      v => /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(v) || '请输入有效的邮箱'
    ],
    organizationRules: [
      v => !!v || '请输入单位名称'
    ],
    telRules: [
      v => !!v || '请输入有效的手机号码',
      v => /^1[3-9][0-9]{9}$/.test(v) || '请输入有效的手机号码'
    ],
    // 参观预约表单项
    bookForm: {
      lxrxm: '',
      lxyx: '',
      gsjg: '',
      lxdh: ''
    }
  }),

  methods: {
    reset () {
      this.$refs.form.reset()
    },
    // 预约表单提交
    async submit () {
      if (this.bookForm.lxrxm.length > 0 & this.bookForm.lxyx.length > 0 & this.bookForm.gsjg.length > 0 & this.bookForm.lxdh.length > 0) {
        if (this.valid) {
          const { data: res } = await this.$axios.post('erp/f/web/saveYyInfor', { waYyinfor: this.bookForm })
            .then(
              this.reset(),
              this.dialog = true,
              this.valid = false
            ).catch(
            )
          this.dialog_tip = res
        }
      } else {
        this.dialog = true
        this.dialog_tip = '请填写正确的信息'
        this.valid = false
      }
    }
  }
}
</script>

<style scoped>
.theme--light.v-btn.v-btn--disabled {
    color: rgba(225,225,225, 0.6) !important;
}

</style>
